import React, { useState, useEffect, useRef } from "react";
import "./index.less";
import { Breadcrumb, message, Modal, Pagination, Tabs } from 'antd';
import { request } from "@/utils/request"
import Config from "@/config/config";
import { formatTimestampToDate } from "@/utils/func";
import { ExclamationCircleOutlined, RightOutlined } from '@ant-design/icons';
import { APPOINTMENT_STATUS, APPOINTMENT_STATUS_NAME, GOOD_ORDER_STATUS, GOOD_ORDER_STATUS_NAME, ORDER_STATUS, ORDER_STATUS_NAME, PAYMENT_STATUS, REFOUND_AMOUNT_STATUS, REFOUND_AMOUNT_STATUS_NAME, REFOUND_DEPOSIT_STATUS, REFOUND_DEPOSIT_STATUS_NAME } from "@/constant";
import { useNavigate } from "react-router-dom";
import gift from '@/assets/gift.png'
import NavigationBar from "@/components/NavigationBar";

export default function Order() {
    const [page, setPage] = useState(1)
    const [perPage, setPerPage] = useState(12)
    const [total, setTotal] = useState(0)
    const [list, setList] = useState([])
    const [current_status, setCurrentStatus] = useState('')
    const logId = useRef('')
    const navigate = useNavigate()
    const items = [
        {
            key: '',
            label: '全部',
        },
        {
            key: '1',
            label: '待处理'
        },
        {
            key: '2',
            label: '待使用',
        },
        {
            key: '3',
            label: '未成交',
        },
        {
            key: '4',
            label: '已完成',
        },
    ];
    const getOrder = async (page, perPage, order_status = '',) => {
        try {
            let url = 'goodseat_order/list' + `?page=${page}&per-page=${perPage}`;
            if (order_status) {
                url += "&order_status=" + order_status
            }
            const response = await request.get(url);
            let data = response.data
            console.log(data, '00000')
            setList(data)
            setTotal(response._meta.totalCount)
        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    };
    const pageChange = (e, v) => {
        console.log(e, v);
        setPage(e)
        setPerPage(v)
        getOrder(e, v);
    }
    useEffect(() => {
        getOrder(page, perPage, current_status);
    }, [page, perPage, current_status]);
    const sureCancel = () => {
        request.post('goodseat_order/cancel', { id: logId.current }).then(r => {
            message.success('取消成功')
            setTimeout(() => {
                getOrder(page, perPage, current_status);
            }, 500)
        })
    }
    const sureDel = () => {
        request.post('goodseat_order/delete', { id: logId.current }).then(r => {
            message.success('删除成功')
            setTimeout(() => {
                getOrder(page, perPage, current_status);
            }, 500)
        })
    }


    const [modalCancel, contextHolderCancel] = Modal.useModal();
    const confirmCancel = () => {
        modalCancel.confirm({
            title: '取消预约',
            icon: <ExclamationCircleOutlined />,
            content: '您确定要取消预约吗',
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
                sureCancel()
            },
            maskClosable: true,
        });
    };
    const [delCancel, contextHolderDel] = Modal.useModal();
    const confirmDel = () => {
        delCancel.confirm({
            title: '删除订单',
            icon: <ExclamationCircleOutlined />,
            content: '您确定要删除吗',
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
                sureDel()
            },
            maskClosable: true,
        });
    };
    const submitPay = (id, order_no) => {
        navigate('/pay?id=' + id + '&sn=' + order_no + '&type=1&from=order')
    }
    return (
        <div className="order">
            <div className="order-title">
                <div className="order-title-box">
                    <Breadcrumb separator="">
                        {sessionStorage.getItem("mbx") === null && <Breadcrumb.Item href="/">主页</Breadcrumb.Item>}
                        {sessionStorage.getItem("mbx") === 'main' && <Breadcrumb.Item href="/">主页</Breadcrumb.Item>}
                        {sessionStorage.getItem("mbx") === 'canteen' && <Breadcrumb.Item href="/canteen">餐厅</Breadcrumb.Item>}
                        {sessionStorage.getItem("mbx") === 'transfer' && <Breadcrumb.Item href="/transfer">好位转让</Breadcrumb.Item>}
                        <Breadcrumb.Separator>
                            <RightOutlined />
                        </Breadcrumb.Separator>
                        <Breadcrumb.Item>好位购买订单</Breadcrumb.Item>
                    </Breadcrumb>
                </div>
            </div>
            <div className="order-tab">
                <div className="order-tab-content">
                    <Tabs current={current_status} items={items} onChange={v => { setCurrentStatus(v) }} />
                </div>
            </div>
            <div className="order-content">
                <div className="order-content-net">
                    <div className="order-item-content">
                        {
                            list?.map((item, index) => {
                                return (
                                    <div className="order-item" key={index} >
                                        <div className="order-top">
                                            <div className="order-code">
                                                <div className="label">
                                                    预约号：
                                                </div>
                                                <div className="orderNum">
                                                    {item.order_no}
                                                </div>
                                            </div>
                                            {
                                                <div className={[4, 6, 9].includes(item.sub_status) ? "status01" : "status"}>{GOOD_ORDER_STATUS_NAME[item.sub_status]?.name}</div>
                                            }
                                        </div>
                                        <div className="order-info" onClick={() => {
                                            navigate(`/transferOrderDetail?id=${item.id}`)
                                        }}>
                                            <div className="order-cover-info">
                                                <img className="order-cover" src={Config.imgPrefix + item?.good_seat_resp?.covers?.split('||')[0]} alt="" />
                                                {
                                                    !!item.raffle && <img className="icon" src={gift} />
                                                }

                                            </div>

                                            <div className="order-info-content">
                                                <div className="order-info-title">
                                                    {item?.good_seat_resp?.name}
                                                </div>
                                                <div className="order-info-time">预约时间：{formatTimestampToDate(item?.good_seat_resp?.reservation_date_confirm)} {item?.good_seat_resp?.reservation_time_confirm}</div>
                                                <div className="order-info-time">
                                                    <div>预定数量：</div>
                                                    <div>{item?.buy_seats_amount}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="order-amount">
                                            合计<span style={{ color: '#C59D60' }}>￥{item.reservation_total_amount}</span>
                                        </div>
                                        {
                                            item.order_status == ORDER_STATUS.waitPay && item.sub_status !== GOOD_ORDER_STATUS.in_the_draw &&
                                            <div className="order-btns">
                                                {/* 未支付 */}
                                                <div className="order-btns-gray" onClick={(e) => {
                                                    e.stopPropagation()
                                                    logId.current = item.id
                                                    confirmCancel()
                                                }}>取消预约</div>
                                                {contextHolderCancel}
                                                <div className="order-btns-active"
                                                    onClick={() => submitPay(item.id, item.order_no)}
                                                >立即支付</div>
                                            </div>
                                        }
                                        {
                                            item.order_status == ORDER_STATUS.tobeUsed && item.sub_status == GOOD_ORDER_STATUS.tobeUsed &&
                                            <div className="order-btns">
                                                <div className="order-btns-active" onClick={(e) => {
                                                    e.stopPropagation()
                                                    navigate(`/diningCompleted?id=${item.id}&type=2`)
                                                }}>就餐完成</div>
                                            </div>
                                        }
                                        {
                                            // 取消预约订单
                                            (item?.order_status === ORDER_STATUS.notTransacted ||
                                                (item?.order_status === ORDER_STATUS.completed && item?.sub_status !== GOOD_ORDER_STATUS.refounding))
                                            &&
                                            <div className="order-btns">
                                                {/* 删除 */}
                                                <div className="order-btns-gray" onClick={(e) => {
                                                    e.stopPropagation();
                                                    logId.current = item.id
                                                    confirmDel()
                                                }}>删除订单</div>
                                                {contextHolderDel}
                                            </div>
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>
                    {
                        !!list?.length && <Pagination
                            className='main-pagination'
                            total={total}
                            pageSize={perPage}
                            pageSizeOptions={[12, 24, 36, 48]}
                            onChange={pageChange}
                            showQuickJumper
                            showTotal={(total) => `共${total}条`}
                            current={page}
                        />
                    }

                </div>

            </div>
        </div>
    );

}

